import {
  DataFileInterface,
  fileInputAcceptTypes,
  FileSelectorModal,
  FileSelectorModalProps,
  FileSourceEnum,
  FileUploaderDropZone,
} from '@systemeio/file-manager'
import { BinIcon } from '@systemeio/ui'
import { useRef, useState } from 'react'
import Option from '../../components/Option'

type FileUploadProps = {
  label: string
  file: DataFileInterface | undefined
  updateFile: (value: DataFileInterface) => void
  removeFile: () => void
}

function FileUpload({ label, file, updateFile, removeFile }: FileUploadProps) {
  const [opened, setOpened] = useState(false)
  const uploaderRef = useRef() as NonNullable<
    FileSelectorModalProps['fileUploaderModalProps']
  >['uploaderRef']
  const fileSelectorRef = useRef() as FileSelectorModalProps['fileSelectorRef']

  return (
    <Option label={label}>
      {file ? (
        <div className="flex flex-row gap-2 break-all">
          {file.name}

          <button onClick={removeFile} className={'group outline-hidden'}>
            <BinIcon
              className={`main-transition-colors group-hover:fill-danger group-focus-visible:fill-danger h-[16px] w-[16px]`}
            />
          </button>
        </div>
      ) : (
        <>
          <FileUploaderDropZone
            acceptTypes={fileInputAcceptTypes.image}
            openNativeWindow={false}
            onClick={() => {
              setOpened(true)
            }}
            onSelectFile={(file: File) => {
              setOpened(true)
              setTimeout(() => {
                fileSelectorRef?.current.setFileUploadModalOpen(true)
                uploaderRef?.current?.setWaitingUploadFiles(prev => [...prev, { file }])
              })
            }}
          />

          <FileSelectorModal
            opened={opened}
            uploadingFromSource={FileSourceEnum.Editor}
            fileSelectorRef={fileSelectorRef}
            disabledFileTypeSelect
            fileUploaderModalProps={{
              uploaderRef,
            }}
            onSelect={file => {
              setOpened(false)
              updateFile(file)
            }}
            onClose={() => setOpened(false)}
          />
        </>
      )}
    </Option>
  )
}

export default FileUpload
